export const PLAN_ENG_NET_COMMISSIONING = {
  ROOT: '/planEngNetCommissioning',
};
